import {call, put, select, takeLatest} from "redux-saga/effects";
import {
  getExamAction,
  getExamActionDone,
  getExamActionFail,
} from "./actions";
import {apiExam} from "./api";
import {PayloadAction} from "@reduxjs/toolkit";

function* getExamFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiExam, payload)
    if (data) {
      yield put(getExamActionDone(data))
    }

  } catch (e) {
    yield put(getExamActionFail())
  }
}

export default function* profileSaga() {
  yield takeLatest(getExamAction, getExamFlow);
}
